import React from 'react';
import ContainerTemplate from '../../../widgets/template/Container';
import UsuEntidadesView from './UsuEntidadesView';
import * as ROUTES from '../../../router/Routes';

const UsuEntidadesModule = () => {
  return (
    <ContainerTemplate active={ROUTES.usuEntidades} routes={[]}>
      <UsuEntidadesView />
    </ContainerTemplate>
  );
};

export default UsuEntidadesModule;
